export const enum AnchorButtonTypeEnum {
  link = 'link',
  danger = 'danger',
  warning = 'warning',
  info = 'info',
  success = 'success',
  secondary = 'secondary',
  primary = 'primary',
}
